import React from "react";
import SignIn from "./signin/signin.js";
import { Paper } from "@mui/material";
import styles from "./login.module.css";

function Login() {
  const companyLogo = `${process.env.REACT_APP_BASE_API}/${process.env.REACT_APP_COMPANY_LOGO}`;

  return (
    <div className={styles.main}>
      <div className={styles.leftPanel}>
        <div
          style={{
            backgroundImage: `url(${companyLogo})`,
            backgroundSize: "cover",
          }}
          className={styles.logo}
        ></div>
        <h1 className={styles.welcomeText}>Welcome Back!</h1>
        <p className={styles.subtitle}>Log in to access your account.</p>
      </div>

      <div className={styles.rightPanel}>
        <Paper
          elevation={8}
          className={`${styles.paper} ${styles.shadowEffect}`}
        >
          <h2 className={styles.formTitle}>ZenGen</h2>
          <div className={styles.formContent}>
            <SignIn />
          </div>
        </Paper>
      </div>

      {/* Mobile View */}
      <div className={styles.mobileView}>
        <div
          style={{
            backgroundImage: `url(${companyLogo})`,
          }}
          className={styles.mobileLogo}
        ></div>
        <h1 className={styles.mobileTitle}>ZenGen</h1>
        <div className={styles.mobileFormContent}>
          <SignIn />
        </div>
      </div>
    </div>
  );
}

export default Login;
